import { createRouter, createWebHistory } from 'vue-router'
import Payment from '../views/payment/index.vue'
import PayCallback from '../views/paycallback/index.vue'
import NotFound from '../views/NotFound.vue'

const routes = [
  {
    path: '/:locale',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/paycallback',
    name: 'PayCallback',
    component: PayCallback
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  }
]
console.log(process.env.VUE_APP_HISTORY_URL, 'process.env.VUE_APP_HISTORY_URL')
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_HISTORY_URL),
  routes
})

export default router
